import { request, qs } from './api';

// Location moderation — coordinate correction only (no create/delete).
// All endpoints require the admin JWT (handled by request()).

// GET /admin/location?page&limit&search&type&missing
//   -> { data:[{id,place_type,name,lat,lon}], total, page, limit }
//   type: place|city|state|country (optional) · missing: true|false (optional)
export const listLocations = (params) => request(`/location${qs(params)}`);

// PUT /admin/location/:type/:id { lat?, lon? } -> { data: Row }. At least one of
// lat/lon required (none -> 400). `type` is the row's place_type.
export const updateLocation = (type, id, body) =>
  request(`/location/${type}/${id}`, { method: 'PUT', body });

// POST /admin/location/bulk — [{ type, id, lat?, lon? }, ...] (update only, no delete)
// -> { data: { results, updated, deleted, failed, total } }
export const bulkLocations = (items) => request('/location/bulk', { method: 'POST', body: items });
